import React from "react";
import styled from "styled-components";
import Image from "../parts/Image";
import Tag from "../parts/Tag";
import Text from "../parts/Text";
import Divider from "../parts/Divider";
import {
  GetUserRequestShops200ResponseInner,
  GetUserRequestShops200ResponseInnerApprovalStatusEnum,
} from "../../../api/v1";
import cafectSampleImage from "../../assets/images/cafect_sample.webp";
import { Link } from "react-router";

type ShopListComponentProps = {
  shops: Array<GetUserRequestShops200ResponseInner>;
};

const ShopCardsStyle = styled(Link)`
  display: flex;
  border-top: 1px solid #dbdbdb;
  text-decoration: none;
  padding: 30px;

  &:hover {
    background-color: #eeeeee;
    transition: background-color 0.3s ease-in-out;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 10px;
  }
`;

const ShopCardColumnLeft = styled.div`
  margin-right: 20px;

  @media (max-width: 767px) {
    margin-right: 0;

    img {
      width: 100%;
    }
  }
`;

const ShopCardColumnRight = styled.div`
  width: 100%;
`;

const ShopInformation = styled.div``;

const RequestShopList: React.FC<ShopListComponentProps> = ({ shops }) => {
  const ShopNameWithApprovalStatus = ({
    shopName,
    approvalStatus,
  }: {
    shopName: string;
    approvalStatus: GetUserRequestShops200ResponseInnerApprovalStatusEnum;
  }) => {
    switch (approvalStatus) {
      case GetUserRequestShops200ResponseInnerApprovalStatusEnum.Approved:
        return (
          <Text size="24px" weight="bold" mb="5px">
            承認済み：{shopName}
          </Text>
        );
      case GetUserRequestShops200ResponseInnerApprovalStatusEnum.Rejected:
        return (
          <Text size="24px" weight="bold" mb="5px">
            却下：{shopName}
          </Text>
        );
      default:
        return (
          <Text size="24px" weight="bold" mb="5px">
            未承認：{shopName}
          </Text>
        );
    }
  };

  return (
    <>
      {shops.map((shop) => {
        return (
          <ShopCardsStyle key={shop.id} to={`/user/request-shops/${shop.id}`}>
            <ShopCardColumnLeft>
              <Image
                src={shop.images[0] ? shop.images[0]?.url : cafectSampleImage}
                width="300px"
                height="170px"
              />
            </ShopCardColumnLeft>
            <ShopCardColumnRight>
              <ShopNameWithApprovalStatus
                shopName={shop.name}
                approvalStatus={shop.approvalStatus}
              />
              <Text size="14px" mb="10px">
                {shop.description}
              </Text>
              <ShopInformation>
                {shop.owner && <Tag mr="5px">公式</Tag>}
                {shop.nearestStation && (
                  <Tag mr="5px">{shop.nearestStation}</Tag>
                )}
                {shop.features
                  .map((feature) => feature.name)
                  .includes("モーニング") && <Tag mr="5px">モーニング</Tag>}
                {shop.features
                  .map((feature) => feature.name)
                  .includes("ランチ") && <Tag mr="5px">ランチ</Tag>}
                {shop.features
                  .map((feature) => feature.name)
                  .includes("ディナー") && <Tag>ディナー</Tag>}
                <Divider mt="5px" mb="5px" />
                <Text size="12px">住所：{shop.address}</Text>
                <Text size="12px">TEL：{shop.tel}</Text>
              </ShopInformation>
            </ShopCardColumnRight>
          </ShopCardsStyle>
        );
      })}
    </>
  );
};

export default RequestShopList;
